import Header from '@/components/Header';
import MenuSection from '@/components/MenuSection';
import Footer from '@/components/Footer';
import Cart from '@/components/Cart';
import { useCart } from '@/context/CartContext';
import PageSEO from '@/components/PageSEO';
import JsonLd from '@/components/JsonLd';
import { pizzas, focacce } from '@/data/menu';

const MenuPage = () => {
  const { ordersEnabled } = useCart();

  const allItems = [...pizzas, ...focacce];
  const menuSchema = {
    '@context': 'https://schema.org',
    '@type': 'Menu',
    name: 'Menù Pizzeria La Torre',
    hasMenuSection: [
      {
        '@type': 'MenuSection',
        name: 'Le Classiche',
        hasMenuItem: pizzas
          .filter((p) => p.category === 'classiche')
          .map((p) => ({
            '@type': 'MenuItem',
            name: p.name,
            description: p.ingredients.join(', '),
            offers: { '@type': 'Offer', price: p.price.toFixed(2), priceCurrency: 'EUR' },
          })),
      },
      {
        '@type': 'MenuSection',
        name: 'Le Nostre Specialità',
        hasMenuItem: pizzas
          .filter((p) => p.category === 'specialita')
          .map((p) => ({
            '@type': 'MenuItem',
            name: p.name,
            description: p.ingredients.join(', '),
            offers: { '@type': 'Offer', price: p.price.toFixed(2), priceCurrency: 'EUR' },
          })),
      },
      {
        '@type': 'MenuSection',
        name: 'Le Focacce',
        hasMenuItem: focacce.map((p) => ({
          '@type': 'MenuItem',
          name: p.name,
          description: p.ingredients.join(', '),
          offers: { '@type': 'Offer', price: p.price.toFixed(2), priceCurrency: 'EUR' },
        })),
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background">
      <PageSEO
        title="Menù – Pizzeria La Torre, Carmagnola (TO)"
        description="Scopri il menù della Pizzeria La Torre: pizze classiche, specialità e focacce. Disponibili anche senza glutine con certificazione AIC."
      />
      <JsonLd
        id="breadcrumb"
        data={{
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'Home',
              item: 'https://www.pizzerialatorrecarmagnola.it/',
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: 'Menù',
              item: 'https://www.pizzerialatorrecarmagnola.it/menu',
            },
          ],
        }}
      />
      <JsonLd id="menu" data={menuSchema} />
      <Header />
      <main className="pt-20">
        <MenuSection />
      </main>
      <Footer />
      {ordersEnabled && <Cart />}
    </div>
  );
};

export default MenuPage;
